import { router } from 'expo-router'
import { Platform } from 'react-native'
import { useUnistyles } from 'react-native-unistyles'

import UserAvatarButton from '@/components/navigation/UserAvatarButton'
import TourSpot from '@/components/tour/TourSpot'
import UniIconButton from '@/components/unistyles/UniIconButton'
import { useAppStore } from '@/store/useAppStore'
import buildOrgPath from '@/utils/orgRoute'

const FosterGridHeaderContent = () => {
  const { theme } = useUnistyles()

  const basicFilters = useAppStore.use.basicFilters()
  const advancedFilters = useAppStore.use.advancedFilters()

  const dirtyFilters =
    (advancedFilters.isActive && advancedFilters.isDirty) ||
    (basicFilters.isActive && basicFilters.isDirty)

  return (
    <>
      {Platform.OS !== 'web' && (
        <TourSpot id="search-button">
          <UniIconButton
            icon="magnify"
            onPress={() => {
              router.push(buildOrgPath('/search'))
            }}
            testID="search-icon-button"
          />
        </TourSpot>
      )}

      <TourSpot id="filter-button">
        <UniIconButton
          icon={dirtyFilters ? 'filter-check' : 'filter-outline'}
          iconColor={dirtyFilters ? theme.colors.primary : undefined}
          onPress={() => {
            router.push(buildOrgPath('/fosters/filters'))
          }}
          testID="filter-button"
        />
      </TourSpot>

      <TourSpot id="user-settings">
        <UserAvatarButton />
      </TourSpot>
    </>
  )
}

export default FosterGridHeaderContent
